import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';

function Refund() {
  return (
    <div className="legal-page">
      <header className="legal-header">
        <nav className="container">
          <Link to="/" className="back-link">← 返回首页</Link>
        </nav>
      </header>
      <div className="container">
        <h1>退款政策</h1>
        <p className="last-updated">最后更新：2024年11月</p>

        <section className="legal-section">
          <h2>引言</h2>
          <p>杭州斯代拉科技有限公司（以下简称"本公司"）致力于为客户提供优质的移动应用开发服务。为保障双方权益，特制定本退款政策。</p>
          <p>本政策适用于所有通过本公司官网或其他渠道购买的开发服务。</p>
        </section>

        <section className="legal-section">
          <h2>1. 可全额退款的情况</h2>
          <p>在以下情况下，客户有权申请全额退款：</p>

          <h3>1.1 项目启动前</h3>
          <ul>
            <li>签订合同后7天内，项目尚未正式启动开发</li>
            <li>客户提出书面退款申请</li>
            <li>双方协商一致终止合作</li>
          </ul>

          <h3>1.2 因本公司原因无法交付</h3>
          <ul>
            <li>因本公司技术能力不足无法完成项目</li>
            <li>因本公司原因导致项目延期超过约定时间50%以上</li>
            <li>本公司单方面终止项目</li>
            <li>本公司违反合同约定的其他重大情形</li>
          </ul>

          <h3>1.3 交付产品严重不符</h3>
          <ul>
            <li>交付产品与合同约定的功能严重不符（缺失50%以上核心功能）</li>
            <li>存在重大技术缺陷，经3次修复仍无法正常使用</li>
            <li>交付产品侵犯第三方知识产权</li>
          </ul>

          <p className="refund-note"><strong>退款时限：</strong>符合全额退款条件的，本公司将在确认后7-15个工作日内退还全部款项。</p>
        </section>

        <section className="legal-section">
          <h2>2. 可部分退款的情况</h2>

          <h3>2.1 项目进行中客户要求终止</h3>
          <ul>
            <li>项目已启动开发，客户因自身原因要求终止</li>
            <li>按已完成工作量结算，退还未完成部分的费用</li>
            <li>工作量计算方式：
              <ul>
                <li>需求分析阶段：10%</li>
                <li>设计阶段：20%</li>
                <li>开发阶段：按实际完成功能模块比例计算（最高50%）</li>
                <li>测试阶段：80%</li>
                <li>已交付：100%</li>
              </ul>
            </li>
          </ul>

          <h3>2.2 客户需求变更导致项目终止</h3>
          <ul>
            <li>客户频繁变更需求，导致项目无法继续</li>
            <li>客户提出的新需求与原合同差异过大</li>
            <li>扣除已投入成本（人力、时间、第三方服务费用等）后退还剩余款项</li>
          </ul>

          <h3>2.3 双方协商一致部分退款</h3>
          <ul>
            <li>因不可抗力导致项目无法继续</li>
            <li>双方协商同意的其他情况</li>
          </ul>

          <p className="refund-note"><strong>退款时限：</strong>双方确认退款金额后，本公司将在7-15个工作日内退还相应款项。</p>
        </section>

        <section className="legal-section">
          <h2>3. 不予退款的情况</h2>
          <p>以下情况不予退款：</p>

          <h3>3.1 项目已完成并交付</h3>
          <ul>
            <li>项目已按合同约定完成开发</li>
            <li>客户已验收通过</li>
            <li>源代码和文档已交付</li>
          </ul>

          <h3>3.2 客户验收通过后</h3>
          <ul>
            <li>客户已签署验收确认书</li>
            <li>客户已支付尾款</li>
            <li>项目已正式上线运营</li>
          </ul>

          <h3>3.3 因客户原因导致项目无法进行</h3>
          <ul>
            <li>客户未按约定提供必要资料和配合</li>
            <li>客户未按约定支付款项</li>
            <li>客户失联超过30天</li>
            <li>客户要求开发违法违规功能</li>
          </ul>

          <h3>3.4 超出退款申请期限</h3>
          <ul>
            <li>项目交付后超过30天未提出异议</li>
            <li>合同终止后超过60天未申请退款</li>
          </ul>

          <h3>3.5 其他不予退款情况</h3>
          <ul>
            <li>客户对设计风格、界面美观度等主观因素不满意（但符合行业标准）</li>
            <li>客户自行修改代码导致的问题</li>
            <li>第三方服务费用（如服务器、域名、第三方API等）</li>
            <li>已使用的技术支持服务</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. 退款流程</h2>

          <h3>4.1 提交退款申请</h3>
          <p>客户需通过以下方式提交书面退款申请：</p>
          <ul>
            <li>发送邮件至：454784911@qq.com</li>
            <li>或致电：15000416741</li>
            <li>或添加客服QQ：454784911</li>
          </ul>
          <p>申请中需包含：</p>
          <ul>
            <li>客户姓名/公司名称</li>
            <li>合同编号</li>
            <li>退款原因</li>
            <li>退款金额</li>
            <li>联系方式</li>
          </ul>

          <h3>4.2 审核处理</h3>
          <ul>
            <li>本公司收到申请后，将在3个工作日内进行审核</li>
            <li>如需补充材料，将及时通知客户</li>
            <li>审核通过后，与客户确认退款金额和方式</li>
          </ul>

          <h3>4.3 签署协议</h3>
          <ul>
            <li>双方签署项目终止协议或退款协议</li>
            <li>明确退款金额、退款方式、项目交接等事项</li>
            <li>客户需退还已交付的源代码和文档（如适用）</li>
          </ul>

          <h3>4.4 退款执行</h3>
          <ul>
            <li>协议签署后，本公司将在7-15个工作日内完成退款</li>
            <li>退款方式：原路退回（银行转账、微信、支付宝等）</li>
            <li>如原支付方式无法退款，可协商其他方式</li>
          </ul>

          <h3>4.5 退款确认</h3>
          <ul>
            <li>客户收到退款后，请及时确认</li>
            <li>如有问题，请在3个工作日内联系我们</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>5. 售后服务期内的退款</h2>
          <ul>
            <li>在免费售后服务期内，如发现重大bug或功能缺陷，本公司将免费修复</li>
            <li>如经3次修复仍无法解决，客户可申请部分退款</li>
            <li>退款金额根据问题严重程度协商确定，一般为合同金额的10%-30%</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>6. 客户投诉与争议解决</h2>

          <h3>6.1 投诉渠道</h3>
          <p>如对服务有任何不满或需要投诉，请通过以下方式联系我们：</p>
          <ul>
            <li><strong>客服电话：</strong>15000416741（工作日 9:00-18:00）</li>
            <li><strong>客服QQ：</strong>454784911</li>
            <li><strong>电子邮箱：</strong>454784911@qq.com</li>
          </ul>

          <h3>6.2 投诉处理流程</h3>
          <ul>
            <li><strong>接收投诉：</strong>24小时内响应</li>
            <li><strong>调查核实：</strong>2个工作日内完成调查</li>
            <li><strong>提出方案：</strong>3个工作日内给出解决方案</li>
            <li><strong>执行方案：</strong>双方确认后立即执行</li>
            <li><strong>回访确认：</strong>问题解决后进行回访</li>
          </ul>

          <h3>6.3 争议解决</h3>
          <ul>
            <li>双方应本着友好协商的原则解决退款争议</li>
            <li>协商不成的，可向消费者协会或相关部门投诉</li>
            <li>仍无法解决的，提交杭州市余杭区人民法院诉讼解决</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>7. 特殊说明</h2>

          <h3>7.1 第三方费用</h3>
          <ul>
            <li>已支付的第三方服务费用（服务器、域名、短信、支付接口等）不予退还</li>
            <li>如客户需要，可协助转移相关服务</li>
          </ul>

          <h3>7.2 定制开发的特殊性</h3>
          <ul>
            <li>软件开发属于定制化服务，一旦开始开发即产生成本</li>
            <li>退款金额需考虑已投入的人力、时间等成本</li>
            <li>建议客户在签约前充分沟通需求，避免后期变更</li>
          </ul>

          <h3>7.3 知识产权</h3>
          <ul>
            <li>退款后，客户需删除所有已交付的源代码和文档</li>
            <li>不得继续使用或传播相关代码</li>
            <li>违反者将承担法律责任</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>8. 服务承诺</h2>
          <p>我们承诺：</p>
          <ul>
            <li>公平、公正处理每一个退款申请</li>
            <li>及时响应客户诉求，不推诿扯皮</li>
            <li>按承诺时限完成退款</li>
            <li>保护客户隐私和商业机密</li>
            <li>持续改进服务质量，减少退款发生</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>9. 政策更新</h2>
          <ul>
            <li>本公司保留随时修改本退款政策的权利</li>
            <li>修改后的政策将在网站上公布，并注明更新日期</li>
            <li>已签订的合同按合同约定执行，不受政策更新影响</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>10. 联系我们</h2>
          <p>如对本退款政策有任何疑问，或需要申请退款，请联系我们：</p>
          <ul>
            <li><strong>公司名称：</strong>杭州斯代拉科技有限公司</li>
            <li><strong>联系电话：</strong>15000416741</li>
            <li><strong>客服QQ：</strong>454784911</li>
            <li><strong>电子邮箱：</strong>454784911@qq.com</li>
            <li><strong>工作时间：</strong>周一至周五 9:00-18:00</li>
            <li><strong>公司地址：</strong>浙江省杭州市余杭区高教镇凤仪大道966号2号楼6层603室6414室</li>
          </ul>
        </section>

        <section className="legal-section">
          <p className="legal-note">感谢您选择杭州斯代拉科技有限公司。我们将竭诚为您提供优质的服务，并在必要时妥善处理退款事宜。</p>
        </section>
      </div>
    </div>
  );
}

export default Refund;
